const pushToDataLayer = (pageEvent) => {
    //@ts-ignore
    window && window.dataLayer && window.dataLayer.push(pageEvent);
};
export const GTMPageView = (page) => {
    const pageEvent = {
        event: "pagechange",
        page,
    };
    if (document.readyState !== "complete") {
        window.addEventListener("load", () => pushToDataLayer(pageEvent), { once: true });
    }
    else {
        pushToDataLayer(pageEvent);
    }
    return pageEvent;
};
//@ts-ignore
export const GTMAdtraction = (id, code) => {
    const event = {
        event: "adtraction_event",
        transactionId: id,
        transactionPromoCode: code,
        transactionTotal: 0,
        md5: "",
    };
    //@ts-ignore
    window && window.dataLayer && window.dataLayer.push(event);
    return event;
};
export const GTMOrderEvent = (orderid) => {
    const event = {
        event: "order_event",
        transactionId: orderid,
    };
    //@ts-ignore
    window && window.dataLayer && window.dataLayer.push(event);
    return event;
};
